export default __webpack_public_path__ + "static/media/prev-NDNU-2.a57062a9.png";